import { PerBookingFieldTypeInBookingFields } from "@mono/essentials/entities/cart/types"
import { OrderItemType, ProductFieldType } from "@mono/essentials/types/OrderTypes"

export const getParticipantFieldsInfoOfOrderItem = ({
  orderItem,
  allParticipantsFieldsData,
  perParticipantFieldsValues,
}: {
  orderItem?: OrderItemType
  allParticipantsFieldsData?: ProductFieldType[]
  perParticipantFieldsValues?: PerBookingFieldTypeInBookingFields[]
}) => {
  if (typeof orderItem === "undefined" || allParticipantsFieldsData?.length === 0) return []
  const requiredUnitIds = orderItem?.quantities?.map(
    (participantCategory) => participantCategory?.unit?.id
  )
  const fields: Record<string, boolean | string | string[] | number>[] = []
  let participantNumber = 1
  let prevUnitId = ""
  orderItem.quantities.forEach((unitGroup) => {
    return unitGroup?.participants?.forEach((participant) => {
      if (requiredUnitIds?.includes(unitGroup?.unit?.id)) {
        const correspondingPerParticipantFieldsDetails = perParticipantFieldsValues?.filter(
          (ppf) =>
            ppf.booking_participant_id === participant.id &&
            ppf.order_item_id === orderItem.id &&
            ppf.field_dump.product_field.product_id === orderItem.product.id
        )
        if (prevUnitId === unitGroup.unit.id) {
          participantNumber += 1
        } else {
          participantNumber = 1
          prevUnitId = unitGroup.unit.id
        }
        const participantFields: Record<string, boolean | string | string[] | number> = {}
        allParticipantsFieldsData?.forEach((fieldData) => {
          if (
            fieldData?.allowed_internal_booking &&
            fieldData?.ask?.includes("ask_per_participant")
          ) {
            // TODO: Using the lable for now bacause the BE doesn't have any unique IDs between the per order field value and domain lavel fields data
            const correspondingPerParticipantFieldDetails =
              correspondingPerParticipantFieldsDetails?.find(
                (correspondingPerParticipantFieldInfo) =>
                  correspondingPerParticipantFieldInfo.field.label === fieldData.label
              )
            participantFields[fieldData?.field?.name] =
              correspondingPerParticipantFieldDetails?.value
                ? fieldData.field.type === "checkbox"
                  ? Array.isArray(correspondingPerParticipantFieldDetails.value)
                    ? correspondingPerParticipantFieldDetails.value
                    : JSON.parse(`${correspondingPerParticipantFieldDetails.value ?? []}`)
                  : correspondingPerParticipantFieldDetails.value
                : fieldData?.field?.type === "checkbox"
                  ? []
                  : ""
            participantFields[`${fieldData?.field?.name}_id`] = fieldData?.id ?? ""
            participantFields[`${fieldData?.field?.name}_order_item_field_id`] =
              correspondingPerParticipantFieldDetails?.id ?? ""
          }
        })
        participantFields.participantGroupName = unitGroup?.unit?.name
          ? `${unitGroup.unit.name} ${participantNumber}`
          : "Participant"
        participantFields.participantUnitId = unitGroup?.unit?.id ?? ""
        participantFields.participantId = participant?.id
        participantFields.id = participant?.id
        fields.push(participantFields)
      }
    })
  })
  return fields
}
